import { render, staticRenderFns } from "./production-order-product-table.vue?vue&type=template&id=1a8959f4&scoped=true"
import script from "./production-order-product-table.ts?vue&type=script&lang=ts&external"
export * from "./production-order-product-table.ts?vue&type=script&lang=ts&external"
import style0 from "./production-order-product-table.scoped.scss?vue&type=style&index=0&id=1a8959f4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8959f4",
  null
  
)

export default component.exports